<script setup lang="ts">
import { ref, shallowRef, watchEffect } from 'vue'
import TaskAttachment from '../TaskAttachment.vue'
import { isNative } from '../../utils'
import { Table } from '../../types/components/data-rendering'
import { useTaskProfiles } from '../../store/useTaskProfiles'
import { storeToRefs } from 'pinia'
import FilteringDataDisplay from '../FilteringDataDisplay.vue'
import FetchPdf from '../FetchPdf.vue'
import { useFilteringDisplayOptions } from '../../composables/useFilteringDisplayOptions'
const loading = ref(true)
const data = shallowRef<Table>({ data: [], meta: { columns: {} } })

watchEffect(
  async () => {
    const { taskIndex } = storeToRefs(useTaskProfiles())
    data.value = taskIndex.value
    loading.value = false
  },
  { flush: 'post' }
)

const isFetching = ref(false)
const setFetching = (e: any) => (isFetching.value = e)
const { taskListDisplayOptions } = useFilteringDisplayOptions({
  isFetching,
})
</script>
<template>
  <FilteringDataDisplay
    v-if="data"
    :key="`taskIndex-${loading}`"
    :is-loading="loading"
    :table-data="data"
    :display-type="displayType"
    :options="taskListDisplayOptions"
  >
    <template #attachment="{ rowData, filterData }">
      <TaskAttachment
        :key="JSON.stringify(rowData['attachment'])"
        truncate
        :attachment="rowData['attachment']"
        :filter-data="filterData"
      />
    </template>
    <!-- Actions for checked data -->
    <template v-if="isNative" #actions="{ checkedData }">
      <FetchPdf :data="checkedData" field="attachment" @is-fetching="setFetching" />
    </template>
  </FilteringDataDisplay>
</template>
